import React from "react";
import "./Guide.css";
import GuideHeader from "./GuideHeader";
import CTAButton from "../CTAButton/CTAButton";
import ManagedFaqSection, { pageFaqDefaults } from "../ManagedFaqSection/ManagedFaqSection";

const Guide = () => {
  return (
    <div className="guide-wrapper">
      {/* 🌊 Hero Section */}
    <GuideHeader />

      {/* 🚀 Start Section */}
      <ManagedFaqSection
        pageKey="guide"
        heading="Email marketing guide FAQs"
        fallback={pageFaqDefaults.guide}
      />

      <section className="guide-start">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
        <CTAButton className="primary-btn">Get started</CTAButton>
      </section>
    </div>
  );
};

export default Guide;
